import ProfileIcon from 'Images/SVG/Profile.svg'
import DownArrowIcon from 'Images/SVG/ChevronDown.svg'
import Stack from '@careguide/stack'
import Link from 'next/link'
import React, { useState } from 'react'
import UpgradeCta from '../UpgradeCta'
import { Image } from 'components/generic/HomePageComponents'
import VisuallyHidden from '@reach/visually-hidden'
import { HeaderLink } from '../HeaderLink'
import { DropdownButton, DropdownPopover } from '../DropdownLink'
import { Badge } from '@careguide/badge'

export type NavDesktopLoggedInProps = {
  links: any[]
  myProfileTitle: string
  myProfileItems: any[]
  showUpgradeCta: boolean
  unreadMessageCount: number
}

export const NavDesktopLoggedIn = ({
  myProfileTitle,
  myProfileItems,
  showUpgradeCta,
  links,
  unreadMessageCount,
}: NavDesktopLoggedInProps) => (
  <>
    <Stack gap='5' direction='horizontal'>
      {links.map((item) =>
        item.isNextLink ? (
          <Link key={item.title} href={item.link} passHref>
            <HeaderLink>
              {item.title}
              {item.isInbox && unreadMessageCount > 0 && (
                <Badge size='small' variant='sponsored'>
                  {unreadMessageCount}
                </Badge>
              )}
            </HeaderLink>
          </Link>
        ) : (
          <HeaderLink key={item.title} href={item.link}>
            {item.title}
            {item.isInbox && unreadMessageCount > 0 && (
              <Badge size='small' variant='sponsored'>
                {unreadMessageCount}
              </Badge>
            )}
          </HeaderLink>
        )
      )}
    </Stack>
    <Stack gap='4' align='right' valign='center' direction='horizontal'>
      {showUpgradeCta && <UpgradeCta />}
      <NavDesktopProfileDropdown title={myProfileTitle} profileNavigationItems={myProfileItems} />
    </Stack>
  </>
)

const NavDesktopProfileDropdown = ({ title, profileNavigationItems }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <>
      <VisuallyHidden>
        {profileNavigationItems.map((item, index) =>
          item.isNextLink ? (
            <Link key={index} href={item.link}>
              <a>{item.title}</a>
            </Link>
          ) : (
            <a key={index} href={item.link}>
              {item.title}
            </a>
          )
        )}
      </VisuallyHidden>
      <div
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
        onClick={() => setIsExpanded(false)}
      >
        {/* The items in this dropdown are rendered as visually hidden elements for screen readers. */}

        <DropdownButton role='button' isExpanded={isExpanded} aria-hidden>
          <Image
            src={ProfileIcon}
            height='16px'
            width='16px'
            pr='6px'
            pb='8px'
            alignSelf='center'
          />
          {title}
          <Image
            src={DownArrowIcon}
            height='16px'
            width='16px'
            pr='6px'
            pb='8px'
            alignSelf='center'
          />
        </DropdownButton>
        {isExpanded && (
          <DropdownPopover aria-hidden>
            <Stack>
              {profileNavigationItems.map((item, index) =>
                item.isNextLink ? (
                  <Link key={index} href={item.link} passHref>
                    <HeaderLink>{item.title}</HeaderLink>
                  </Link>
                ) : (
                  <HeaderLink key={index} href={item.link}>
                    {item.title}
                  </HeaderLink>
                )
              )}
            </Stack>
          </DropdownPopover>
        )}
      </div>
    </>
  )
}
